import axios, { AxiosError, AxiosInstance } from 'axios';
// config

// ----------------------------------------------------------------------

const axiosInstance = axios.create();

declare global {
  interface Window {
    DD_RUM?: {
      addError: (error: unknown, context?: Record<string, unknown>) => void;
    };
    __BOL_DD_422_INTERCEPTOR_ATTACHED__?: boolean;
  }
}

const getRequestUrl = (error: AxiosError) => {
  const { baseURL, url } = error.config ?? {};

  if (!url) {
    return undefined;
  }

  if (!baseURL) {
    return url;
  }

  try {
    return new URL(url, baseURL).toString();
  } catch {
    return `${baseURL}${url}`;
  }
};

const report422ToDatadog = (error: AxiosError) => {
  if (typeof window === 'undefined' || error.response?.status !== 422) {
    return;
  }

  const responseData = (error.response.data ?? {}) as {
    message?: unknown;
    errors?: unknown;
  };

  window.DD_RUM?.addError('API 422', {
    url: getRequestUrl(error),
    method: error.config?.method,
    status: error.response.status,
    responseData: {
      message: responseData.message,
      errors: responseData.errors
    }
  });
};

const attachResponseInterceptor = (
  client: AxiosInstance,
  onReject: (error: AxiosError) => Promise<never>
) => {
  client.interceptors.response.use(
    (res) => res,
    (error: AxiosError) => {
      report422ToDatadog(error);
      return onReject(error);
    }
  );
};

if (typeof window === 'undefined' || !window.__BOL_DD_422_INTERCEPTOR_ATTACHED__) {
  attachResponseInterceptor(axios, (error) => Promise.reject(error));

  if (typeof window !== 'undefined') {
    window.__BOL_DD_422_INTERCEPTOR_ATTACHED__ = true;
  }
}

attachResponseInterceptor(axiosInstance, (error) =>
  Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args: any) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  cart: import.meta.env.VITE_CART_API_URL,
  profiles: import.meta.env.VITE_CART_API_URL + '/profiles',
  availability: import.meta.env.VITE_SEARCH_API_URL
};
